import * as React from 'react';
import {Suspense, useState} from 'react';
import {ReactKeycloakProvider} from '@react-keycloak/web';
import keycloak from './utils/keycloak';
import {AppRouter} from './components/common/router/AppRouter';
import {positions, Provider as AlertProvider} from 'react-alert';
// @ts-ignore
import AlertTemplate from 'react-alert-template-basic';

const maintenance = process.env.REACT_APP_MAINTENANCE_MODE && process.env.REACT_APP_MAINTENANCE_MODE == 'true' || false;
console.log('maintentance: ' + (maintenance ? 'true' : 'false'));

const App = () => {
  const [keyCloakError, setKeyCloakError] = useState();
  const eventLogger = (event: unknown, error: any) => {
    if (error) {
      console.log('onKeycloakEvent', event, error);
      setKeyCloakError(error.error);
    }
  };

  return (
    <AlertProvider template={AlertTemplate} position={positions.MIDDLE} timeout={10000} title="Virhe"
      offset="50px">
      {maintenance &&
        <div>
          <div className="container-fluid header py-4">
            <div className="row  px-4">
              <div className="col-auto me-auto logo">
                <img src="/img/digiviesti-fi.png" className="img-fluid" alt="logo" />
                <div id='maintenance'><h1>HUOLTOKATKO!</h1></div>
              </div>
            </div>
          </div>
        </div>
      }
      {!maintenance &&
        <ReactKeycloakProvider authClient={keycloak} onEvent={eventLogger}>
          <Suspense fallback="{Loading}">
            <AppRouter keyCloakError={keyCloakError} maintenance={false} />
          </Suspense>
        </ReactKeycloakProvider>
      }
    </AlertProvider>
  );
};

export default App;
